import { render } from "./Groups.vue?vue&type=template&id=3bd31132&scoped=true&ts=true"
import script from "./Groups.vue?vue&type=script&lang=ts"
export * from "./Groups.vue?vue&type=script&lang=ts"

import "./Groups.vue?vue&type=style&index=0&id=3bd31132&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd31132"]])

export default __exports__